import { Grid, useMediaQuery } from "@mui/material";
import { BooleanField, DateField, Labeled, ReferenceField, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { erasmusRequests } from "api/erasmusApi";
import { SectionTitle } from "features/SectionTitle";

const MobilitySection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record) return null;

  // XOR on create - either a university from the nomenclature or free text
  const universityId = record.userInfo?.universityId;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Мобилност"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Статус">
            <ReferenceField
              source="userInfo.internshipStatus"
              reference={erasmusRequests.getInternshipStatusesSelect()}
              emptyText="-"
              link={false}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Университет">
            {universityId ? (
              <ReferenceField
                source="userInfo.universityId"
                reference={administrationRequests.getUniversitiesSelect()}
                emptyText="-"
                link={false}
              >
                <TextField source="name" />
              </ReferenceField>
            ) : (
              <TextField
                source="userInfo.universityName"
                emptyText="-"
              />
            )}
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Желае общежитие">
            <BooleanField source="userInfo.wantsDormitory" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Дата на пристигане">
            <DateField
              source="userInfo.arrivalDate"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <Labeled label="Дата на приключване">
            <DateField
              source="userInfo.finishDate"
              locales="bg-BG"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
        >
          <Labeled label="Мотивацонно писмо">
            <TextField
              source="userInfo.shortMotivationLetter"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default MobilitySection;
